import React, { ReactNode } from 'react';

interface FooterBottomProps {
  children: ReactNode;
  className?: string;
}

export const FooterBottom: React.FC<FooterBottomProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`footer_bottom pt-8 flex flex-col md:flex-row justify-between items-center ${className}`}>
      {children}
    </div>
  );
};
